import { get, put } from "@/lib/api";

function getHeadersWithOrderId(options) {
  if (options?.orderId) {
    return { "x-order-id": String(options.orderId) };
  }
  return {};
}

function withOrderQuery(path, orderId) {
  if (!orderId) {
    return path;
  }
  const params = new URLSearchParams();
  params.set("order_id", String(orderId));
  return `${path}?${params.toString()}`;
}

/**
 * Get DIY payload for a specific template slug
 */
export async function getDiy(slug, options = {}) {
  return get(withOrderQuery(`/diy/${slug}`, options?.orderId), {
    useAuth: true,
    useApiKey: true,
    headers: getHeadersWithOrderId(options),
  });
}

/**
 * Update DIY payload for a specific template slug
 */
export async function updateDiy(slug, payload, options = {}) {
  const body = { payload };
  if (options?.orderId) {
    body.order_id = String(options.orderId);
  }
  return put(
    `/diy/${slug}`,
    { payload },
    { 
      useAuth: true, 
      useApiKey: true,
      headers: getHeadersWithOrderId(options),
    },
    withOrderQuery(`/diy/${slug}`, options?.orderId),
    body,
    { useAuth: true, useApiKey: true },
  );
}

/**
 * Check if DIY is ready for a specific template slug
 */
export async function checkDiyStatus(slug, options = {}) {
  return get(withOrderQuery(`/diy/${slug}/check`, options?.orderId), {
    useAuth: true,
    useApiKey: true,
    headers: getHeadersWithOrderId(options),
  });
}
